export default __webpack_public_path__ + "static/media/img-wallet.4b18e877.svg";